import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TooltipIconComponent } from '../../../shared/components/tooltip-icon/tooltip-icon.component';
import { NgIf } from '@angular/common';
import { FormControl } from '@angular/forms';
import { SelectItem, SelectMenuComponent, SelectMode } from '../../../shared/components/select-menu/select-menu.component';
import { AskPolarisButtonComponent } from '../../copilot/components/ask-polaris/ask-polaris-button/ask-polaris-button.component';
import { AskPolarisWidgetConfig } from '../../copilot/types';
import { VolumeFilterComponent } from '../../../shared/components/volume-filter/volume-filter.component';

@Component({
  selector: 'app-widget-header',
  imports: [
    TooltipIconComponent,
    NgIf,
    SelectMenuComponent,
    AskPolarisButtonComponent,
    VolumeFilterComponent
  ],
  templateUrl: './widget-header.component.html',
  styleUrl: './widget-header.component.scss'
})
export class WidgetHeaderComponent<T> {

  @Input() titleText: string = '';
  @Input() subTitleText: string = '';
  @Input() tooltipText: string = '';

  @Input({ required: true }) control!: FormControl<T>;
  @Input() selectMode: SelectMode = SelectMode.MULTI;
  @Input() selectOptions: SelectItem<T>[] = [];
  @Input() iconPath: string = '';
  @Input() placeholder: string = '';
  @Input() searchable: boolean = true;
  @Input() compareWith!: (option1: any, option2: any) => boolean;

  @Input() selectDisabled: boolean = false;
  @Input() selectWidth: string = '100%';
  @Input() selectSearchPlaceholder: string = 'Search item';
  @Input() hideSelected: boolean = false;
  @Input() selectAllAndClearOptions: boolean = false;
  @Input() showAllSelected: boolean = false;
  @Input() showSelectedIcon: boolean = false;
  @Input() showPlaceholderIcon: boolean = false;
  @Input() showPlaceholderAllSelected: boolean = false;
  @Input() selectDropdownWideWidth: boolean = false;

  @Input() secondControl!: FormControl<any>;
  @Input() secondSelectOptions: SelectItem<T>[] = [];
  @Input() secondPlaceholder: string = '';
  @Input() secondSelectWidth: string = '100%';
  @Input() secondSelectSearchPlaceholder: string = 'Search item';

  @Input() askPolarisWidget: AskPolarisWidgetConfig | undefined;
  @Input() selectedMetrics?: string[];
  @Input() showVolumeFilter: boolean = false;
  @Output() apply = new EventEmitter<void>();
  @Output() volumeFilterApplied = new EventEmitter<number | null>();

  get showSelect(): boolean {
    return Boolean(this.control && this.selectOptions?.length);
  }

  get showSecondSelect(): boolean {
    return Boolean(this.secondControl && this.secondSelectOptions?.length);
  }

  onApply() {
    this.apply.emit();
  }

  onVolumeFilterApplied(value: number | null) {
    this.volumeFilterApplied.emit(value);
  }
}
